import { motion } from "framer-motion";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// Staff Page
const StaffPage = () => {
  const staffMembers = [
    { name: "Desireé Murphy Morrissey", title: "Chief Executive Officer", image: "https://customer-assets.emergentagent.com/job_market-for-good/artifacts/18yhv0r3_Desiree%20professional.jpg" },
    { name: "Kyra Raphaelidis", title: "Chief Operating Officer", image: null },
    { name: "Maria Atanacio", title: "Director of Special Projects", image: null },
    { name: "Phyllis Lamarr", title: "Pantry Manager", image: null },
    { name: "Joshua Morehead", title: "Driver", image: null },
    { name: "Marian McPhillips", title: "Volunteer Coordinator", image: null }
  ];

  return (
    <div data-testid="staff-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/mtyipsqi_Greeting%20clients.jpg"
        alt="Murphy's Giving Market Staff"
        objectPosition="center top"
      />

      {/* Staff Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 
              data-testid="staff-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-12"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Staff
            </h1>
            
            <div className="space-y-6">
              {staffMembers.map((member, index) => (
                <motion.div
                  key={member.name}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 flex items-center gap-4"
                >
                  {member.image && (
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="w-36 h-36 rounded-lg object-cover object-top flex-shrink-0"
                    />
                  )}
                  <div>
                    <h3 
                      className="font-bold text-[#1A1A1A] text-xl mb-1"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                    >
                      {member.name}
                    </h3>
                    <p className="text-[#C41E3A] font-medium">{member.title}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default StaffPage;
